export default {
  methods: {

    transformToImageUrl (path = '') {
      return `${process.env.VUE_APP_API_BASE_URL}/${path}`
    }

  }
}
